// 2カラムの要素を、実際の表示位置（上→下、同じ高さでは左→右）で並べる。
// CSS transform の演出に影響されないよう、offset座標を使う。
(function () {
  'use strict';

  window.wfGalleryVisualSort = function (elements) {
    return Array.prototype.slice.call(elements).map(function (element, domIndex) {
      var current = element;
      var top = 0;
      var left = 0;

      while (current) {
        top += current.offsetTop || 0;
        left += current.offsetLeft || 0;
        current = current.offsetParent;
      }

      return {
        element: element,
        domIndex: domIndex,
        top: top,
        left: left,
      };
    }).sort(function (a, b) {
      if (Math.abs(a.top - b.top) <= 2) {
        return a.left - b.left || a.domIndex - b.domIndex;
      }
      return a.top - b.top;
    }).map(function (entry) {
      return entry.element;
    });
  };
})();

// ギャラリーアーカイブ用スクロール演出
// .js-reveal が付いたカードを GSAP + ScrollTrigger で順番にフェードインさせる。
// gsap本体は footer.php 末尾(wp_footer後)で読み込まれるため、DOMContentLoaded後に初期化する。
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    var items = window.wfGalleryVisualSort(document.querySelectorAll('.js-reveal'));
    if (!items.length) return;

    gsap.set(items, { autoAlpha: 0, y: 36 });

    ScrollTrigger.batch(items, {
      start: 'top 88%',
      once: true,
      onEnter: function (batch) {
        gsap.to(batch, {
          autoAlpha: 1,
          y: 0,
          duration: 1.2,
          ease: 'power3.out',
          stagger: 0.1,
          overwrite: true,
          clearProps: 'transform',
        });
      },
    });

    // 画像読み込みで高さが変わるため、load後にトリガー位置を再計算
    window.addEventListener('load', function () {
      ScrollTrigger.refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// 一覧の列数切り替え(2列 / 1列)
// テンプレート側のトグルは template-parts/photo-view-toggle.php
// 対象リストと保存キーはトグルの data-target / data-key で指定する
(function () {
  'use strict';

  var toolbar = document.querySelector('.js-photo-view-toggle');
  if (!toolbar) return;

  var list = document.querySelector(toolbar.dataset.target || '.p-gallery-photo__list');
  var buttons = toolbar.querySelectorAll('.p-gallery-photo__view-btn');
  if (!list || !buttons.length) return;

  var KEY = toolbar.dataset.key || 'wfPhotoListCols';

  function apply(cols) {
    list.classList.toggle('is-cols-1', cols === '1');
    buttons.forEach(function (btn) {
      var active = btn.dataset.cols === cols;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    // 列数変更で高さが変わるため、スクロール演出のトリガー位置を再計算
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      apply(btn.dataset.cols);
      try { localStorage.setItem(KEY, btn.dataset.cols); } catch (e) {}
    });
  });

  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  if (saved === '1') apply('1');
})();
